import {createReducer} from '@reduxjs/toolkit';
import {SetCategories, SetCategoriesPagination} from './ActionTypes/Category';

interface CategoryState {
  categories: any[];
  categoriesPagination: {count: number; pages: number};
}

const initialState: CategoryState = {
  categories: [],
  categoriesPagination: {count: 0, pages: 0},
};

const categoryReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SetCategories, (state, action) => {
      state.categories = action.payload;
    })
    .addCase(SetCategoriesPagination, (state, action) => {
      state.categoriesPagination = action.payload;
    });
});

export default categoryReducer;
